import { useRootLoaderData } from './useRootLoaderData';

export function useCurrentPartner() {
  const data = useRootLoaderData();
  return data?.currentPartner;
}
